<template>
	<div style="width: 100%;">
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item><i class="el-icon-date"></i> 表单</el-breadcrumb-item>
				<el-breadcrumb-item>编辑器</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div style="height: 15px;">

		</div>
		<div style="width: 100%;">
			<editor :id='randomId' v-model='content_defaultValue' :init='init'></editor>
		</div>

	</div>

</template>
<script>
	import Common from './js/Common';
	import tinymce from 'tinymce/tinymce'
	import 'tinymce/themes/mobile/theme'
	import 'tinymce/themes/silver/theme'
	import Editor from "@tinymce/tinymce-vue";
	import 'tinymce/plugins/image'
	import 'tinymce/plugins/media'
	import 'tinymce/plugins/link'
	import 'tinymce/plugins/image'
	import 'tinymce/plugins/code'
	import 'tinymce/plugins/table'
	import 'tinymce/plugins/lists'
	import 'tinymce/plugins/wordcount'
	import 'tinymce/plugins/colorpicker'
	import 'tinymce/plugins/textcolor'
	import 'tinymce/plugins/contextmenu'
	import store from 'store/'
	import {
		gbs
	} from 'config/'
	
	var COS = require('cos-js-sdk-v5'); /* 安装命令 npm i cos-js-sdk-v5 --save */
	var Js = Common('tinymce-editor');
	Js.mixins = [{
		data() {
			return {
				tinymceHTML: 'hello world',
				init: {
					language_url: '/static/zh_CN.js',
					language: 'zh_CN',
					skin_url: '/static/tinymce/skins/ui/oxide',
					height: 430,
					plugins: 'link lists image code table colorpicker textcolor wordcount contextmenu media',
					toolbar: [
						'image bold italic underline strikethrough | fontsizeselect | forecolor backcolor ',
						'alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote',
						'undo redo | link unlink  code | removeformat media'
					],
					convert_urls: false,
					branding: false,
					media_live_embeds: true,
					images_upload_handler: function(blobInfo, succFun, failFun) {

						var fileObj = blobInfo.blob(); //转化为易于理解的file对象
						
						var cos = new COS({
							SecretId: 'AKIDxjFUTBdoW2KNAi15tSmrgGZdQ3RaS3OT',
							SecretKey: 'rSpysXx72h6GBqGRM2SfdMq55sPghSyE',
						});
									
						self.size = fileObj.size;
						var key = 'foluonong/' + new Date().getTime() + fileObj.name;
						var obj = fileObj.name.lastIndexOf(".");
						self.ext = fileObj.name.substr(obj + 1);
						self.orginName = fileObj.name;
						self.start_time = new Date().getTime();
						
						cos.putObject({
							Bucket: 'fln-1305430688',
							/* 必须 */
							Region: 'ap-chengdu',
							/* 存储桶所在地域，必须字段 */
							Key: key,
							/* 必须 */
							StorageClass: 'STANDARD',
							Body: fileObj, // 上传文件对象
							onProgress: function(progressData) {
								var progressRes = progressData;
								console.log('progressRes', progressRes)
								self.setProgress(progressRes.percent)
							}
						}, function(err, data) {
							console.log('err', err, data)
							var newUrl = 'http://' + data.Location; //获取到了图片的URL
							succFun(newUrl);
						});
						
					}

				},
				defaultProps: {
					children: 'child',
					label: 'title',
					value: 'id',
				},
				editorOption: {
					modules: {
						toolbar: '#editorAb',
						imageResize: {
							displaySize: true
						},
					},
				},
				content: {},
				image_array: [],
				content_defaultValue: '',
				tinymceHtml: '请输入内容',
				randomId: ''

			}
		},
		components: {
			Editor
		},
		computed: {
			editor: {
				get: function() {
					const self = this;
					return self.$refs.myTextEditor.quill;
				},
				set: function(newValue) {
					const self = this;
					self.$refs.myTextEditor.quill = newValue;
				}
			}

		},
		created() {
			this.content_defaultValue = this.defaultValue;
			self.randomId = Math.ceil(Math.random() * 10000) + 'map';
			this.init.selector = '#' + self.randomId;
		},
		mounted() {
			tinymce.init({})
		},
		watch: {

			content_defaultValue(val) {
				const self = this;
				this.$emit('onChange', {
					field: this.field,
					value: this.content_defaultValue
				})
			},
			defaultValue(val) {
				const self = this;
				self.content_defaultValue = this.defaultValue;
			},

		},
		methods: {

			inittest() {
				const self = this;
				self.content_defaultValue = this.defaultValue;
				console.log('init-self.idArr', self.idArr)
			},

			onEditorChange({
				quill,
				html,
				text,
				iamge
			}) {
				const self = this;
				self.content = html;
				this.$emit('onChange', {
					field: self.field,
					value: html
				})
			},


			getIdArrByHtml(html) {
				const self = this;
				var imgReg = /<img.*?(?:>|\/>)/gi;
				var srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
				var imgIdReg = /id(\S*)\./i;
				var arr = html.match(imgReg);
				if (!arr) {
					arr = [];
				};
				var idArr = [];
				for (var i = 0; i < arr.length; i++) {
					idArr.push(arr[i].match(imgIdReg)[1]);
				};
				return idArr;
			},


			onEditorFocus(editor) {
				const self = this;
				self.editor = editor //当content获取到焦点的时候就 存储editor
			},

			customButtonClick() {
				const self = this;
				var range
				if (self.editor.getSelection() != null) {
					range = self.editor.getSelection()
					self.length = range.index //content获取到焦点，计算光标所在位置，目的为了在该位置插入img
				} else {
					self.length = self.content.length //content没有获取到焦点时候 目的是为了在content末尾插入img
				}
				self.$el.querySelector('.custom-input').click(); //打开file 选择图片
			},


			/**
			 * 根据数组的长度，来决定需要递归几次，最终取出需要的结果，我曹，没法解释，解释不清的玩意。
			 * @param  {array}  areas 地区列表，无线分类结构
			 * @param  {array}  temps 一维数组,如果只有一个，代表取顶级;如果两个，取顶级的子级；如果三个，顶级的子级的子级....以此类推
			 * @param  {number} k     递归次数，当这个值等于temps的长度时，就代表结束了
			 * @return {string}       地区名称
			 */
			onDeepGetCityName(list, temps, k) {
				for (var i = 0; i < list.length; i++) {
					if (list[i].id + '' === temps[k] + '') {
						if (k < temps.length - 1) {
							k = k + 1
							this.temp_field_obj[this.data.key].push(list[i].city)
							this.onDeepGetCityName(list[i].children, temps, k)
						} else {
							// console.log(list[i]);
							this.temp_field_obj[this.data.key].push(list[i].city)
							return
						}
					}
				}
			},

			/**
			 * 最后一级选择完后触发
			 * @param v 选中的值数组，根据这个数组取出对应的文本
			 */
			sonChange(v) {
				this.temp_field_obj[this.data.key] = []
				this.onDeepGetCityName(this.data.options, v, 0)
				this.submit_info[this.data.key] = this.temp_field_obj[this.data.key]
				this.$emit('onChange', [this.data.key, value])
				this.events.change && this.events.change({
					value: v,
					info: this.submit_info[this.data.key]
				})
			},
			onChange(val) {

				this.$emit('onChange', [this.data.key, val[val.length - 1]])

			},

			/**
			 * 每选择一项时就触发这个
			 * 场景：当选择的条件不允许继续选择时，可以使用这个事件
			 * @param v 选中的值数组，根据这个数组取出对应的文本
			 */
			onActiveItemChange(v) {
				this.temp_field_obj[this.data.key] = []
				this.onDeepGetCityName(this.data.options, v, 0)
				this.submit_info[this.data.key] = this.temp_field_obj[this.data.key]
				this.events['active-item-change'] && this.events['active-item-change']({
					value: v,
					info: this.submit_info[this.data.key]
				})
			}
		},


	}]
	export default Js
</script>
<style>
	.tox-tinymce-aux {
		z-index: 9999 !important
	}
</style>



// WEBPACK FOOTER //
// src/components/solely-fields/tinymceEditor.vue